import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import ILCASection from '@/pages/about/components/ILCASection';

// ... existing code ...

export default function ProductsPage() {
  const { t } = useTranslation();

  const products = [
    {
      image: 'https://public.readdy.ai/ai/img_res/cec4d10f7cfc9e705c550009a625c45d.jpg',
      category: t('prod1_cat'),
      title: t('prod1_title'),
      desc: t('prod1_desc'),
      tags: [t('prod1_tag1'), t('prod1_tag2')],
    },
    {
      image: 'https://readdy.ai/api/search-image?query=large%20white%20headsail%20genoa%20jib%20sail%20on%20sailboat%20taut%20and%20full%20of%20wind%20blue%20sky%20background%20close%20up%20of%20sail%20fabric%20texture%20and%20hanks%20professional%20maritime%20photography&width=600&height=500&seq=maxsails-prod-2&orientation=portrait',
      category: t('prod2_cat'),
      title: t('prod2_title'),
      desc: t('prod2_desc'),
      tags: [t('prod2_tag1'), t('prod2_tag2'), t('prod2_tag3')],
    },
    {
      image: 'https://readdy.ai/api/search-image?query=colorful%20spinnaker%20sail%20billowing%20in%20wind%20on%20racing%20sailboat%20bright%20red%20and%20white%20asymmetric%20spinnaker%20full%20of%20air%20dramatic%20sailing%20photography%20on%20open%20water&width=600&height=500&seq=maxsails-prod-3&orientation=portrait',
      category: t('prod3_cat'),
      title: t('prod3_title'),
      desc: t('prod3_desc'),
      tags: [t('prod3_tag1'), t('prod3_tag2')],
    },
    {
      image: 'https://readdy.ai/api/search-image?query=white%20cruising%20sail%20set%20on%20sailboat%20calm%20ocean%20sunset%20light%20tan%20dacron%20fabric%20traditional%20cruising%20sailboat%20with%20full%20sail%20set%20peaceful%20maritime%20scene&width=600&height=500&seq=maxsails-prod-4&orientation=portrait',
      category: t('prod4_cat'),
      title: t('prod4_title'),
      desc: t('prod4_desc'),
      tags: [t('prod4_tag1'), t('prod4_tag2')],
    },
    {
      image: 'https://readdy.ai/api/search-image?query=white%20storm%20sail%20trysail%20small%20heavy%20duty%20sail%20on%20sailboat%20in%20rough%20weather%20conditions%20dark%20sky%20heavy%20fabric%20reinforced%20corners%20professional%20sailing%20photography&width=600&height=500&seq=maxsails-prod-5&orientation=portrait',
      category: t('prod5_cat'),
      title: t('prod5_title'),
      desc: t('prod5_desc'),
      tags: [t('prod5_tag1'), t('prod5_tag2')],
    },
  ];

  useEffect(() => {
    const id = 'schema-products';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: import.meta.env.VITE_SITE_URL },
            { '@type': 'ListItem', position: 2, name: 'Products', item: `${import.meta.env.VITE_SITE_URL}/products` },
          ],
        },
        {
          '@type': 'WebPage',
          '@id': `${import.meta.env.VITE_SITE_URL}/products#webpage`,
          url: `${import.meta.env.VITE_SITE_URL}/products`,
          name: 'Our Products | MAX Sails Canada — Mainsails, Headsails, Spinnakers & More',
          description: "Browse MAX Sails Canada's full range of quality sails — mainsails, headsails, spinnakers, cruising sails and storm sails. Custom sail making at attractive prices.",
          inLanguage: ['en', 'fr'],
          isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
          dateModified: '2026-04-09',
        },
        {
          '@type': 'ItemList',
          '@id': `${import.meta.env.VITE_SITE_URL}/products#itemlist`,
          name: 'MAX Sails Canada Product Range',
          description: 'Full range of quality sails manufactured by MAX Sails Canada',
          numberOfItems: 5,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@type': 'Product',
                name: 'Mainsails',
                description: 'Custom and stock mainsails for racing and cruising sailboats, made with high-quality dacron and laminate fabrics.',
                brand: { '@type': 'Brand', name: 'MAX Sails Canada' },
                offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', url: `${import.meta.env.VITE_SITE_URL}/products` },
              },
            },
            {
              '@type': 'ListItem',
              position: 2,
              item: {
                '@type': 'Product',
                name: 'Headsails & Jibs',
                description: 'High-performance headsails and jibs for racing, day sailing, and ocean cruising.',
                brand: { '@type': 'Brand', name: 'MAX Sails Canada' },
                offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', url: `${import.meta.env.VITE_SITE_URL}/products` },
              },
            },
            {
              '@type': 'ListItem',
              position: 3,
              item: {
                '@type': 'Product',
                name: 'Spinnakers',
                description: 'Asymmetric and symmetric spinnakers for racing and performance sailing.',
                brand: { '@type': 'Brand', name: 'MAX Sails Canada' },
                offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', url: `${import.meta.env.VITE_SITE_URL}/products` },
              },
            },
            {
              '@type': 'ListItem',
              position: 4,
              item: {
                '@type': 'Product',
                name: 'Cruising Sails',
                description: 'Durable cruising sails built for comfort and longevity on extended passages.',
                brand: { '@type': 'Brand', name: 'MAX Sails Canada' },
                offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', url: `${import.meta.env.VITE_SITE_URL}/products` },
              },
            },
            {
              '@type': 'ListItem',
              position: 5,
              item: {
                '@type': 'Product',
                name: 'ILCA / Laser Sails',
                description: 'In-stock ILCA (Laser) class sails — ILCA 4, ILCA 6, and ILCA 7 — ready to ship.',
                brand: { '@type': 'Brand', name: 'MAX Sails Canada' },
                offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', url: `${import.meta.env.VITE_SITE_URL}/products` },
              },
            },
          ],
        },
      ],
    });
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">

        {/* Hero */}
        <section className="relative w-full h-[340px] md:h-[420px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=fleet%20of%20sailboats%20racing%20on%20open%20ocean%20with%20white%20sails%20fully%20deployed%20dramatic%20sky%20and%20deep%20blue%20water%20wide%20angle%20aerial%20photography%20beautiful%20maritime%20scene%20with%20multiple%20boats&width=1920&height=600&seq=maxsails-products-hero&orientation=landscape"
            alt="MAX Sails Canada products"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative z-10 text-center px-6">
            <p className="text-red-400 text-xs uppercase tracking-[0.3em] font-semibold mb-3">{t('products_hero_label')}</p>
            <h1
              className="text-white font-black text-4xl md:text-6xl"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {t('products_hero_title')}
            </h1>
            <p className="text-white/70 text-base md:text-lg mt-4 max-w-lg mx-auto">
              {t('products_hero_subtitle')}
            </p>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="mb-14">
              <p className="text-red-600 text-xs uppercase tracking-[0.3em] font-semibold mb-3">{t('products_section_label')}</p>
              <h2
                className="text-3xl md:text-4xl font-black text-gray-900 leading-tight"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {t('products_section_title')}
              </h2>
              <p className="text-gray-500 mt-4 max-w-xl text-base leading-relaxed">
                {t('products_section_desc')}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {products.map((p) => (
                <div key={p.title} className="group rounded-2xl overflow-hidden border border-stone-100 hover:border-red-100 transition-colors">
                  <div className="w-full h-56 overflow-hidden">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-7">
                    <p className="text-red-600 text-xs uppercase tracking-widest font-semibold mb-2">{p.category}</p>
                    <h3
                      className="text-gray-900 font-bold text-xl mb-3"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      {p.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed mb-5">{p.desc}</p>
                    <div className="flex flex-wrap gap-2">
                      {p.tags.map((tag) => (
                        <span key={tag} className="px-3 py-1 rounded-full bg-stone-100 text-stone-600 text-xs font-medium">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Custom Lettering & Numbering */}
        <section className="py-16 bg-stone-50 border-t border-stone-100">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex flex-col md:flex-row items-center gap-10 rounded-2xl border border-stone-200 bg-white overflow-hidden">
              <div className="w-full md:w-56 h-48 md:h-auto md:self-stretch flex-shrink-0 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=close%20up%20of%20white%20sail%20with%20bold%20black%20sail%20number%20and%20custom%20lettering%20applied%20professionally%20clean%20crisp%20typography%20on%20sailcloth%20fabric%20nautical%20racing%20sail%20number%20detail%20sharp%20focus%20minimal%20background&width=400&height=400&seq=maxsails-custom-lettering&orientation=squarish"
                  alt="Custom sail lettering and numbering"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="flex-1 px-8 py-8 md:py-10">
                <p className="text-red-600 text-xs uppercase tracking-[0.3em] font-semibold mb-3">{t('custom_label')}</p>
                <h2
                  className="text-2xl md:text-3xl font-black text-gray-900 mb-4 leading-tight"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {t('custom_title')}
                </h2>
                <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-xl">{t('custom_desc')}</p>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gray-900 text-white text-sm font-semibold hover:bg-red-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {t('custom_cta')}
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* ILCA / Laser Inventory */}
        <ILCASection />

        {/* CTA */}
        <section className="py-14 bg-stone-900 text-white">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('products_cta')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
}
